module.exports = __webpack_public_path__ + "static/media/31.f6aeee40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/31.svg
// module id = 149
// module chunks = 0